




































































import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import ChromeEditorPanel from '@/components/chrome/EditorPanel.vue';
import ListBody from '@/components/list/ListBody.vue';
import ListItem from '@/components/list/ListItem.vue';
import LoaderInline from '@/components/LoaderInline.vue';
import store from './ProductUseStore';

export default Vue.extend({
  props: {
    value: String,
    resource: String,
  },
  created() {
    !this.$store.state.productUsePanel
      && this.$storeRegister('productUsePanel', store);
  },
  data: () => ({
    hasLoaded: false,
  }),
  computed: mapState('productUsePanel', [
    'count',
    'isLoading',
    'result',
  ]),
  methods: {
    ...mapActions('productUsePanel', [
      'loadProducts',
    ]),
    async load() {
      // load if this hasn't been loaded and there's an ID passed
      // (the value is undefined when the page transitions away from here)
      if (!this.hasLoaded && this.value) {
        await this.loadProducts({
          id: this.value,
          resource: this.resource,
        });
        this.hasLoaded = true;
      }
    },
    panelVisible() {
      this.load();
    },
  },
  watch: {
    value() {
      // change when going between pages
      this.hasLoaded = false;
      this.load();
    },
  },
  components: {
    ChromeEditorPanel,
    ListBody,
    ListItem,
    LoaderInline,
  },
});
